<template>
  <div class="transaction_footer">
    <a class="repeat" title="Повторить" @click="onRepeatPayment">
      {{ $t('common.repeat') }}
    </a>
    <a class="code" :title="$t('get.qr.code')" @click="onFetchQRCode">
      {{ $t('get.qr.code') }}
    </a>
    <a class="share" :title="$t('to.share')" @click="onShareBill">
      {{ $t('to.share') }}
    </a>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'BillCardFooter',
  props: {
    transaction: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters(['SELECTED_TRANSACTION']),
  },
  methods: {
    onRepeatPayment() {
      this.$router.push({
        name: 'Invoicing',
        params: {
          transaction: this.transaction,
        },
      });
    },
    onFetchQRCode() {
      this.SET_MODAL_PARAMS({
        type: 'QR',
        params: {
          show: true,
          type: 'bill',
          bill: this.SELECTED_TRANSACTION,
          code: this.SELECTED_TRANSACTION.public_id,
        },
      });
    },
    onShareBill() {
      this.SET_MODAL_PARAMS({
        type: 'SHARE',
        params: {
          show: true,
          shareInfo: {
            showForm: true,
            id: this.transaction.owner_id,
            url: this.transaction.payLink,
            title: `${this.$t('link.to.pay')} | capusta.space`,
            description: this.transaction.description,
          },
        },
      });
    },
    ...mapMutations(['SET_MODAL_PARAMS']),
  },
};
</script>

<style lang="sass" scoped>
  @mixin square($val)
    width: $val
    height: $val

  %icon-bg
    background:
      color: transparent
      repeat: no-repeat
      position: center

  .transaction_footer
    border-top: 0.08rem solid #E3E3E4
    padding: 2rem
    display: flex
    justify-content: space-between
    +adaptive(mobile)
      padding: 1.5rem 1rem

    a
      color: #9B51E0
      display: flex
      align-items: center
      font-weight: 600
      transition: .2s ease

      .bill &
        font-size: 0
        padding: 0 2rem

      &::before
        content: ''
        display: inline-block
        transition: .2s ease
        +square(2rem)
        @extend %icon-bg

      $buttons: (copy: copy, code: code, share: share, return: backward, receipt: receipt, repeat: repeat, backward: backward-done)

      @each $class, $icon in $buttons
        &.#{$class}
          &::before
            background-image: get-icon($icon, #9B51E0, $transactionFooterIcons)
</style>
